<div class="page-banner">
      <div class="page-banner-image"></div>
      <div class="page-banner-title">
            <h2>Keep Movies</h2>
      </div>
</div>

<div class="page-tools">

      <div class="tools-title">
            <h1>Used in this Project</h1>
      </div>

      <div class="row">
            <div class="col tools">
                  <i class="devicon-angularjs-plain fa-3x"></i>
                  <h3>Angular</h3>
            </div>
            <div class="col tools">
                  <i class="devicon-bootstrap-plain fa-3x"></i>
                  <h3>Bootstrap</h3>
            </div>
            <div class="col tools">
                  <i class="devicon-css3-plain fa-3x"></i>
                  <h3>CSS</h3>
            </div>
            <div class="col tools">
                  <i class="devicon-html5-plain fa-3x"></i>
                  <h3>HTML</h3>
            </div>
      </div>
</div>